module.exports = __webpack_public_path__ + "static/media/bottle_cap_index.0f119ee5.svg";